function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import styles from './SectionTitle.pcss';
var _React_Component;
class SectionTitle extends (_React_Component = React.Component) {
    render() {
        const { children } = this.props;
        return /*#__PURE__*/ _jsx("h2", {
            className: styles.sectionTitle,
            children: children
        });
    }
}
_define_property(SectionTitle, "propTypes", {
    children: PropTypes.node
});
export default withStyles(styles)(SectionTitle);
